// extracted by mini-css-extract-plugin
module.exports = {"main":"Content_main__vb7jG"};